import { useState } from "react";
import PersonIcon from "@mui/icons-material/Person";
// Local
import { ExistingCustomerWithLocations } from "../../models/customer";
import InvoiceTable from "./InvoiceTable";
import { ExistingSiteKeyLocation } from "../../models/site-key-location";
import { QBOInvoiceResponse } from "../../Pages/Quickbooks/QuickbooksSyncErrorsContainer";
import { ExistingStiltInvoice } from "../../models/invoice";
import BaseButtonSecondary from "../BaseButtonSecondary";
import { SELECT_CUSTOMER } from "../../strings";
import CustomerTableDialog from "../customers/CustomerTableDialog";
import StyledMessage from "../StyledMessage";

interface Props {
  siteKey: string;
  currency: string;
  selectedCustomer: ExistingCustomerWithLocations | null;
  setSelectedCustomer: (customer: ExistingCustomerWithLocations) => void;

  invoices: ExistingStiltInvoice[];
  onViewInvoice: (invoiceID: string, acctRefID: string | null) => void;
  onImportSelected: (ids: string[]) => Promise<void>;
  qboInvoices: QBOInvoiceResponse[] | undefined;
  qboInvoicesLoading: boolean;
  siteKeyLocationList: ExistingSiteKeyLocation[];

  children: {
    qboLoadingInvoicesIndicator: React.ReactNode;
  };
}

/** Import Option: Single, Data Type: By Customer */
export default function ImportSingleByCustomerContent(
  props: Props,
): JSX.Element {
  const [dialogOpen, setDialogOpen] = useState(false);

  const selectCustomerButton = (
    <BaseButtonSecondary type="button" onClick={() => setDialogOpen(true)}>
      <PersonIcon fontSize="small" className="mr-2" />
      {SELECT_CUSTOMER}
    </BaseButtonSecondary>
  );

  const selectCustomerDialog = (
    <CustomerTableDialog
      isOpen={dialogOpen}
      onClose={() => setDialogOpen(false)}
      siteKey={props.siteKey}
      onSelectCustomer={(customer) => {
        props.setSelectedCustomer(customer);
        setDialogOpen(false);
      }}
      addCustomerButton={null}
    />
  );

  const invoiceTable = props.selectedCustomer && (
    <InvoiceTable
      invoiceList={props.invoices}
      siteKeyLocationList={props.siteKeyLocationList}
      currency={props.currency}
      onViewInvoice={props.onViewInvoice}
      onImportSelected={props.onImportSelected}
      qboInvoices={props.qboInvoices}
      qboInvoicesLoading={props.qboInvoicesLoading}
      tableMaxHeight="max-h-[42vh]"
    >
      {{
        dateRangePicker: null,
        qboLoadingInvoicesIndicator: props.children.qboLoadingInvoicesIndicator,
      }}
    </InvoiceTable>
  );

  return (
    <>
      <div>
        <div className="mb-4 mt-6 flex items-center gap-6">
          {selectCustomerButton}
          <h2 className="text-lg font-medium">
            {props.selectedCustomer
              ? props.selectedCustomer.name
              : "No customer selected"}
          </h2>
        </div>
        <StyledMessage
          type="info"
          dismissible={false}
          overrideTextAlignment="text-left"
          overrideIconAlignment="self-start"
          overridePadding="px-3 py-2"
        >
          {{
            message: (
              <div className="text-base">
                <p className="text-xl">@Harry</p>
                <p>
                  unimplemented = querying QBO for the customer's invoices and
                  displaying those, whether we have them in Stilt or not.
                </p>
                <p>
                  right now we're querying QBO for specific invoices - all of
                  which obviously exist in Stilt.
                </p>
              </div>
            ),
          }}
        </StyledMessage>

        {invoiceTable}
      </div>
      {selectCustomerDialog}
    </>
  );
}
